import { render, staticRenderFns } from "./VueNumeric.vue?vue&type=template&id=60861b74&"
import script from "./VueNumeric.vue?vue&type=script&lang=js&"
export * from "./VueNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports